import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RowComponent } from './RowComponent';
import { DraggableRow, DragHandle, RowWrapper } from './styled';
import { HolderOutlined } from '@ant-design/icons';

interface SortableRowProps {
  signalMeta: {
    id: string | number;
    name: string;
    [key: string]: any;
  };
  nameColumnWidth: number;
  columnWidth: number;
  onDataUpdate?: (updateFn: (prev: Record<string, number>) => Record<string, number>) => void;
}

export const SortableRow = ({
  signalMeta,
  nameColumnWidth,
  columnWidth,
  onDataUpdate,
}: SortableRowProps) => {
  const eventId = typeof signalMeta.id === 'number' ? String(signalMeta.id) : signalMeta.id;

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: eventId,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <DraggableRow ref={setNodeRef} style={style} {...attributes}>
      <DragHandle {...listeners}>
        <HolderOutlined />
      </DragHandle>
      <RowWrapper>
        <RowComponent
          signalMeta={signalMeta}
          nameColumnWidth={nameColumnWidth}
          columnWidth={columnWidth}
          onDataUpdate={onDataUpdate}
        />
      </RowWrapper>
    </DraggableRow>
  );
};
